import { render, staticRenderFns } from "./AdminStudentsTable.vue?vue&type=template&id=6efb85da&scoped=true"
import script from "./AdminStudentsTable.vue?vue&type=script&lang=js"
export * from "./AdminStudentsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminStudentsTable.vue?vue&type=style&index=0&id=6efb85da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb85da",
  null
  
)

export default component.exports